import { gql } from '@apollo/client';

// Get campaign art and art brief for customer portal
export const GET_CUSTOMER_CAMPAIGN_ART = gql`
  query GetCustomerCampaignArt($campaignId: Int!) {
    customerCampaignArt(campaignId: $campaignId) {
      id
      campaignId
      campaignArtBriefId
      installed
      installedDate
      artChange
      artChangePrice
      createDate
      campaignArtBrief {
        id
        campaignId
        headlineText
        phone
        email
        website
        facebook
        instagram
        twitter
        tikTok
        snapchat
        colors
        conceptFileUrl
        createDate
      }
      campaignArtFiles {
        id
        fileUrl
        thumbnailUrl
        printReady
        createDate
        isDraft
        artProofStatusId
        artProofStatus {
          id
          statusName
        }
        campaignArtNotes {
          id
          note
          createDate
          senderId
          senderTypeId
          noteTypeId
          internalNote
          parentNoteId
          senderType {
            id
            typeName
          }
        }
      }
    }
  }
`;

// Get campaign art files for a specific campaign art
export const GET_CUSTOMER_CAMPAIGN_ART_FILES = gql`
  query GetCustomerCampaignArtFiles($campaignArtId: Int!) {
    customerCampaignArtFiles(campaignArtId: $campaignArtId) {
      id
      fileUrl
      thumbnailUrl
      printReady
      createDate
      isDraft
      artProofStatusId
      artProofStatus {
        id
        statusName
      }
      campaignArtNotes {
        id
        note
        createDate
        senderId
        senderTypeId
        noteTypeId
        internalNote
        parentNoteId
        senderType {
          id
          typeName
        }
      }
    }
  }
`;

